// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

export type Language = 'en' | 'es' | 'es-ES'
export type NameSpaces = 'web'

export const languages: Array<Language> = ['en', 'es', 'es-ES'];
export const nameSpaces: Array<NameSpaces> = ['web'];
